// @flow strict
import * as React from 'react';
//$FlowFixMe[untyped-import]
import {classify} from 'src/utils';
import useI18n from 'src/hooks/useI18n';
import {useEnvironmentContext} from 'src/hooks/useEnvironmentContext';
import {PageName} from '@spaced-out/ui-design-system/lib/components/PageTitle';
//$FlowFixMe[untyped-import]
import {PAGE_NAME_LIST, duotoneIconStyle} from 'src/utils/app-shell';
import flow from 'lodash/flow';
//$FlowFixMe[nonstrict-import]
import {provideHooks} from 'src/flux/provideHooks.jsx';
//$FlowFixMe[nonstrict-import]
import {withWindowWidth} from 'src/flux/responsive.jsx';
//$FlowFixMe[nonstrict-import]
import {fluxify} from 'src/flux/component.jsx';
//$FlowFixMe[nonstrict-import]
import {getAgency} from 'src/action-creators/agency';
//$FlowFixMe[nonstrict-import]
import {getAllEntities} from 'src/action-creators/ats-entities';
import {usePageTitle} from 'src/contexts/page-title-context.jsx';
import {Button} from '@spaced-out/ui-design-system/lib/components/Button';
import {Icon} from '@spaced-out/ui-design-system/lib/components/Icon';
import {
  TEXT_COLORS,
  TitleMedium,
} from '@spaced-out/ui-design-system/lib/components/Text';
import {Tooltip} from '@spaced-out/ui-design-system/lib/components/Tooltip';
import {Separator} from '@spaced-out/ui-design-system/lib/components/Separator';
//$FlowFixMe[untyped-import]
import {CommonTopNavButtons} from 'src/components/app-shell/common-top-nav-buttons.jsx';
import css from './page-title.css';


type ClassNames = $ReadOnly<{
  wrapper?: string,
  topSlot?: string,
  rightSlot?: string,
}>;

export type PageTitleProps = {
  classNames?: ClassNames,
  children?: React.Node,
  pageNameKey?: string,
  showBackButton?: boolean,
  onBack?: () => void,
  rightSlotComponent?: React.Node,
};

export type TabSlotProps = {
  children?: React.Node,
  className?: string,
  ...
};

const dependencies = {
  required: ({dispatch}) => dispatch(getAgency()),
  deferred: ({dispatch}) => dispatch(getAllEntities()),
};

const PageTitleComponent: React$AbstractComponent<
  PageTitleProps,
  HTMLDivElement,
> = React.forwardRef<PageTitleProps, HTMLDivElement>(
  (props: PageTitleProps, ref): React.Node => {
    const {labelI18nInstance} = useI18n();
    const t = labelI18nInstance.t;
    const {pageTitleState: contextState} = usePageTitle();
    const mergedProps = {...contextState, ...props};
    const {
      classNames,
      pageNameKey,
      showBackButton,
      onBack,
      tabSlotComponent,
      customPageNameComponent,
      rightSlotComponent,
      hidePageTitle,
    } = mergedProps;

    const {isExtension, isClientIframe} = useEnvironmentContext();

    const handleBack = () => {
      if (isExtension && onBack) {
        // This additional check for isExtension is to
        // handle the routing in the extension without impacting the route history of parent page
        onBack();
      } else {
        if (window.history.length > 1) {
          // This is a temporary fix, this needs to be practice going forward
          // to handle history.back in the respective components
          window.history.back();
        } else {
          onBack && onBack();
        }
      }
    };

    return !hidePageTitle ? (
      <div
        data-testid="PageTitle"
        className={classify(css.pageTitleWrapper, classNames?.wrapper, {
          [css.pageTitleWrapperWithBottomSlot]: !!tabSlotComponent,
        })}
        ref={ref}
      >
        <div className={classify(css.topSlot, classNames?.topSlot)}>
          <div className={css.headerWithBackBtn}>
            {showBackButton && (
              <Tooltip
                title={t('Navigate_Back', 'Navigate Back')}
                delayMotionDuration="slow"
                placement="top-start"
              >
                <Button
                  onClick={handleBack}
                  type="tertiary"
                  iconLeftName="chevron-left"
                  ariaLabel={t('Navigate_Back_Button', 'Navigate Back Button')}
                />
              </Tooltip>
            )}
            {customPageNameComponent ? (
              customPageNameComponent
            ) : pageNameKey && PAGE_NAME_LIST[pageNameKey] ? (
              <PageName>
                <TitleMedium>{PAGE_NAME_LIST[pageNameKey].title} </TitleMedium>
                <Icon
                  type={PAGE_NAME_LIST[pageNameKey].iconType}
                  name={PAGE_NAME_LIST[pageNameKey].iconName}
                  size="medium"
                  color={TEXT_COLORS.primary}
                  swapOpacity={PAGE_NAME_LIST[pageNameKey].iconSwapOpacity}
                  style={duotoneIconStyle}
                />
              </PageName>
            ) : null}
          </div>
          <div
            className={classify(css.rightContainer, {
              [css.rightContainerWithRightSlot]: null,
            })}
          >
            <div className={css.buttonsSlot}>
              {!tabSlotComponent && !!rightSlotComponent && rightSlotComponent}
              <Separator
                orientation="vertical"
                classNames={{wrapper: css.separator}}
              />
              {!(isExtension || isClientIframe) && <CommonTopNavButtons />}
            </div>
          </div>
        </div>
        {!!tabSlotComponent && (
          <div className={css.bottomSlot}>
            {tabSlotComponent}
            <div className={classify(css.rightSlot, classNames?.rightSlot)}>
              {rightSlotComponent ? rightSlotComponent : null}
            </div>
          </div>
        )}
      </div>
    ) : null;
  },
);

export const PageTitle = (flow(
  withWindowWidth,
  // $FlowFixMe[prop-missing]
  fluxify({}, {pure: true}),
  provideHooks(dependencies),
)(PageTitleComponent): React.ComponentType<PageTitleProps>);
